// extracted by mini-css-extract-plugin
module.exports = {"newscontent-box":"dH","newscontentBox":"dH"};